import React from 'react'
import { Link } from 'react-router-dom'
import styles from './GuideMenu.css'
import { TypeComponentGuideMenu } from "../../constants/consts-prop-types"
import { isInternalLink, getPathFromAbsoluteUrl } from "../../services/service-utils"

const GuideMenu = ({ currentRoute, data }) => {
  const { items = [] } = data
  const activeItems = items.filter((item = {}) => item.guide_menu_active_landing)
  
  const { message: openingHoursMessage } = currentRoute.opening_hours

  return (
    <div className={styles.GuideMenu}>
      <div className={`container-fluid ${styles.container}`}>
        <div className={styles.openingHoursMessage}>
          {openingHoursMessage}
        </div>
        <div className={`row ${styles.row}`}>
          <div className={`col-xs-12 ${styles.listWrapper}`}>
            <ul className={styles.list}>
              {activeItems.map((itemData, idx) => {
                const { title, url, target } = itemData.guide_menu_link
                return (
                  <li key={`listItem-${idx}`}>
                    {isInternalLink(url) ? (
                      <Link to={getPathFromAbsoluteUrl(url)} className={styles.menuItem}>
                        <div className={styles.grower}>
                          {title}
                        </div>
                        <img src={itemData.guide_menu_icon || ''} className={styles.icon} alt="" />
                      </Link>
                    ) : (
                        <a href={url} className={styles.menuItem} target={target}>
                        <div className={styles.grower}>
                          {title}
                        </div>
                        <img src={itemData.guide_menu_icon || ''} className={styles.icon} alt="" />
                      </a>
                    )}
                  </li>                
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

GuideMenu.propTypes = {
  data: TypeComponentGuideMenu
}

export default GuideMenu;



// WEBPACK FOOTER //
// ./src/components/GuideMenu/GuideMenu.js